module.exports = __webpack_public_path__ + "img/creative.57489ef6.jpg";